import React, { useState, useEffect } from 'react';
import ErrorBoundary from 'components/common/ErrorBoundary';
import SizesTable from 'components/Letters/Single/Size/Sidebar/Size/SizesTable';

export default function Size({ vesselId, modifySizes }) {
    const [routeParamsId, setRouteParamsId] = useState(null);

    useEffect(() => {
        setRouteParamsId(vesselId);
        return () => {
            setRouteParamsId(null);
        };
    }, [vesselId]);
    
    return (
        <React.Fragment>
            {
                routeParamsId ?
                    <ErrorBoundary>
                        <SizesTable
                            key={vesselId}
                            routeParams={{ id: routeParamsId }}
                            showAddButton={false}
                            modifySizes={modifySizes}
                        />
                    </ErrorBoundary>
                    :
                    null
            }
        </React.Fragment>
    );
}



// WEBPACK FOOTER //
// ./app/components/Vessels/Composition/Size.jsx